import _extends from "@babel/runtime/helpers/extends";
/**
 * cn-filter 开启 showSelected 时渲染已选项
 */
import React from 'react';
import { transferObjToAvailable } from "../../utils/useDetail";

// -- Todo 有默认值时已选项显示label
export default function RegionItemRender(props) {
  var outerProps = props.outerProps,
    value = props.value,
    itemLabel = props.itemLabel,
    getData = props.getData;
  var arrValue = transferObjToAvailable(value, _extends({}, outerProps));
  var arrLabel = getData(arrValue).map(function (o) {
    return o.label;
  });
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline'
    }
  }, itemLabel, ": ", arrLabel.toString());
}